
class spicesMenu {

    constructor() {
        this.init();
    }

    init() {
        if ($('.spices-menu-kont').length > 0) {
            $('.spices-menu-kont').data('quickjump', 1)
            $('.spices-menu-kont').find('.menuitems a').each(function (ind, el) {
                $(el).on('click', function (e) {
                    e.preventDefault();

                    $('.spices-menu-kont').find('.menuitems a').removeClass('active');
                    $('.spices-menu-kont').find('.menuitems a').removeClass('active no-right-line');
                    $(el).addClass('active');
                    $(el).prev().addClass('no-right-line');

                    if ($('.spices-panel-kont#' + $(this).data('itemtarget')).length > 0) {
                        $('.spices-menu-kont').data('quickjump', 0);
                        var topOffset = 200;
                        if ($('#ccm-page-controls-wrapper').length > 0) {
                            topOffset = 248;
                        }
                        $("html, body").stop().animate({ scrollTop: $('.spices-panel-kont#' + $(this).data('itemtarget')).offset().top - topOffset }, '150', function () {
                            $('.spices-menu-kont').data('quickjump', 1)
                        });
                    }

                })
            })
        }
    }
}

class spicesPanel {

    constructor() {
        this.basePanel = '';

        this.carouselBrakepoints = {
            380: {
                spaceBetween: 0,
                slidesPerView: 1,
                slidesPerGroup: 1,
            },
            580: {
                spaceBetween: 15,
                slidesPerView: 3,
                slidesPerGroup: 3
            },
            980: {
                spaceBetween: 15,
                slidesPerView: 5,
                slidesPerGroup: 5
            },
            1200: {
                spaceBetween: 15,
                slidesPerView: 5,
                slidesPerGroup: 5
            }
        };
    }


    init(baseID) {
        this.basePanel = $('#' + baseID);

        if ($('.spices-panel-kont').length > 0) {

            this.initCarousel(baseID)

            // swiper.on('slidesLengthChange', function () {
            // setTimeout(function () {
            //     spicesPanel.extendCarousel(baseID)
            // }, 5000)
            // });


            /*
            $('.kateg-items-list', this.basePanel).slick({
                infinite: false,
                speed: 800,
                slideToScroll: 5,
                slideToShow: 5,
                autoplay: true,
                autoplaySpeed: 7000,
                arrows: true,
                prevArrow: '<span class="spices-arrow-left"></span>',
                nextArrow: '<span class="spices-arrow-right"></span>'
            });
            */


        }
    }

    initCarousel(baseID) {
        let aktkategList = $('.kateg-items-list', this.basePanel).data("kateg-list");
        if (aktkategList != "") {
            $.get('/index.php/spicepanels/getrestitems', { kategoriak: aktkategList, limit: 10, t: (new Date().getTime()) }, (res) => {

                let newItems = [];
                $.each(res, (indx, resitem) => {
                    newItems.push(resitem.html);
                });

                let aktSwiper = new Swiper('#' + baseID + " .kateg-items-list", {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    spaceBetween: 0,

                    // loop: true,
                    // autoplay: {
                    //     delay: 7000
                    // },
                    breakpoints: this.carouselBrakepoints,
                    navigation: {
                        nextEl: ".spices-arrow-right",
                        prevEl: ".spices-arrow-left",
                    },
                    on: {
                        afterInit: () => {
                            setTimeout(() => {
                                this.extendCarousel(baseID);
                            }, 5000);
                        }
                    }
                });

                aktSwiper.appendSlide(newItems);
                this.updateKedvezmenyPlecsnik(baseID);
            });
        }
    }

    extendCarousel(baseID) {
        let basePanel = $('#' + baseID);
        let aktkategList = $('.kateg-items-list', basePanel).data("kateg-list");
        if (aktkategList != "") {
            $.get('/index.php/spicepanels/getrestitems', { kategoriak: aktkategList, t: (new Date().getTime()) }, (res) => {

                let aktSwiper = $('#' + baseID + " .kateg-items-list").get(0).swiper;
                aktSwiper.destroy(true, true);

                let newItems = [];
                $.each(res, function (indx, resitem) {
                    newItems.push(resitem.html);
                });

                aktSwiper = new Swiper('#' + baseID + " .kateg-items-list", {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    loop: true,
                    autoplay: {
                        delay: 7000
                    },
                    breakpoints: this.carouselBrakepoints,
                    navigation: {
                        nextEl: ".spices-arrow-right",
                        prevEl: ".spices-arrow-left",
                    }
                });

                aktSwiper.appendSlide(newItems);
                this.updateKedvezmenyPlecsnik(baseID);

            });
        }
    }

    updateKedvezmenyPlecsnik(baseID) {
        if (typeof menukedvezmenydatab64 != 'undefined') {
            var menukedvData = JSON.parse(General.base64Decode(menukedvezmenydatab64));

            var basePanel = $('#' + baseID);
            var processedItems = [];

            $('.bottom-panel-kont .kateg-items-list .kateg-item', basePanel).each(function () {
                var itemObj = $(this);

                var itemId = +itemObj.data('id');

                if (processedItems.indexOf(itemId) == -1) {
                    processedItems.push("" + itemId);

                    $.each(menukedvData, function (aid, adata) {

                        if (aid == itemId) {
                            console.log(adata.akcio_merteke, "akval 2");
                            if (+adata.akcio_merteke > 0) {
                                itemObj.find('.akcio-aktiv').removeClass('hide alapszazalek');
                                itemObj.find('.akcio-aktiv span').text(adata.akcio_merteke);
                            } else if (typeof adata.ceges_szazalek != "undefined" && adata.ceges_szazalek > 0) {
                                itemObj.find('.akcio-aktiv').removeClass('hide');
                                itemObj.find('.akcio-aktiv').addClass('alapszazalek')
                                itemObj.find('.akcio-aktiv span').text(adata.ceges_szazalek);
                            } else if (typeof adata.prime_szazalek != "undefined" && adata.prime_szazalek > 0) {
                                itemObj.find('.akcio-aktiv').removeClass('hide');
                                itemObj.find('.akcio-aktiv').addClass('alapszazalek')
                                itemObj.find('.akcio-aktiv span').text(adata.prime_szazalek);
                            } else {
                                itemObj.find('.akcio-aktiv').addClass('hide');
                                itemObj.find('.akcio-aktiv').addClass('alapszazalek')
                                itemObj.find('.akcio-aktiv span').text('');
                            }
                        }

                    })
                }
            })

        }
    }
}

export {
    spicesMenu,
    spicesPanel
};

